import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './create_share.less'
import { getI18n } from 'client/i18n'
import ShareCampaign from 'components/common/share_campaign'

const i18n = getI18n('components/pages/create/pool_share')

class PoolShare extends React.Component {
  static propTypes = {
    campaignId: PropTypes.string,
    poolUrl: PropTypes.string,
    secondaryPoolButton: PropTypes.bool,
  }

  render() {
    return (
      <div>
        <div styleName="share-title">{i18n('share_your_pool')}</div>
        <ShareCampaign campaignId={this.props.campaignId} />
        <a
          data-pa-click="done"
          href={this.props.poolUrl}
          className={`vx_btn vx_btn-block ${this.props.secondaryPoolButton &&
            'vx_btn-secondary'}`}
          styleName="done-button"
        >
          {i18n('go_to_pool')}
        </a>
      </div>
    )
  }
}

export default cssModules(PoolShare, styles)
